export default __webpack_public_path__ + "static/media/cancel.d01b491d.jpg";